import useInfoPopover from '../responsive/useInfoPopover';
import './OpsViewComponent.css';
import sunGlyph from '../Images/sun-glyph.png';
import License1 from '../Images/license-1.png';
import License2 from '../Images/license-2.png';
import License3 from '../Images/license-3.png';
import FDNYRed from '../Images/fdny-red-logo.png';
import MountSinai from '../Images/mount-sinai-logo.png';


const OpsViewComponent = () => {
    const { active: currentPopoverElement, close, containerRef, bind } = useInfoPopover();

    return <div ref={containerRef} className="viewport grid-parent ops-view-layout">
        <div className="darken-overlay" onClick={close} style={currentPopoverElement ? null : { display: 'none' }}></div>
        <div className="time-display-ops">
            <span className="time-span">9:00 AM</span>
            <span className="month-span">Oct 30</span>
            <span id="weather-img"><img id="sun-glyph" src={sunGlyph} alt="sun"/></span>
            <span className="temp-span">48°</span>
        </div>

        <div className="title ops-title">Ops View</div>

        <div 
            id="status-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "status-head" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Status:</span> Active or standby indicator 
            for each responding unit
            <div className="status-straight-line"></div>
            <div id="status-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="address-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "address-head" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Address:</span> Current or assigned 
            destination
            <div className="address-straight-line"></div>
            <div id="address-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="plates-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "plates-head" ? null : {display: 'none'}}
        >
            <span className="popover-strong">ID Plates:</span> Inspired by NY vehicle
            plates, displays each identification 
            number familiar, easy-to-read 
            format. This design helps dispatchers
            recognize units instantly - bringing
            real-world realism to the digital
            command view
            <div className="plates-straight-line"></div>
            <div id="plates-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="unit-popover"
            className="popover-text popover-box"
            style={currentPopoverElement === "unit-head" ? null : {display: 'none'}}
        >
            <span className="popover-strong">Unit:</span> Identifies the responding
            organization, FDNY or partner
            hospitals - for clear source
            visibility
            <div className="unit-straight-line"></div>
            <div id="unit-popover-dot" className="popover-dot">
                <div className="dott outerr dot-grey"></div>
                <div className="dott innerr dot-black"></div>
            </div>
        </div>

        <div 
            id="distance-eta-group" 
            style={(currentPopoverElement === "distance-head" ||
                currentPopoverElement === "eta-head"
            ) ? null : {display: 'none'}}
        >
            <div 
                id="distance-eta-popover"
                className="popover-text popover-box"
            >
                <span className="popover-strong">Distance & Eta:</span> Displays live
                route progress and time to
                arrival, updating automatically
                as conditions change
                <div className="distance-eta-straight-line"></div>
                <div id="distance-eta-popover-dot" className="popover-dot">
                    <div className="dott outerr dot-grey"></div>
                    <div className="dott innerr dot-black"></div>
                </div>
                <div id="distance-eta-popover-dot-2" className="popover-dot">
                    <div className="dott outerr dot-grey"></div>
                    <div className="dott innerr dot-black"></div>
                </div>
            </div>
        </div>

        <div className="ops-table grid-parent">
            <div id="select-table-item"></div>

            <span
                {...bind("status-head")}
                className="header-text"
            >
                Status
            </span>
            <span
                {...bind("address-head")}
                className="header-text"
            >Address  ↓</span>
            <span
                {...bind("plates-head")}
                className="header-text"
            >ID  ↓</span>
            <span
                {...bind("unit-head")}
                className="header-text"
            >Unit</span>
            <span
                {...bind("distance-head")}
                className="header-text"
            >Distance</span>
            <span
                {...bind("eta-head")}
                className="header-text"
            >ETA</span>

            <div id="active-1" className="active-button">Active</div>
            <div id="active-2" className="active-button">Active</div>
            <div id="active-3" className="active-button">Active</div>

            <span id="two-seventy-west-end">270 West End Ave</span>
            <div id="grand-central-terminal">Grand Central Terminal</div>

            <img id="license-1" src={License1} className="license-plate-img" alt="NY License Plate Example" />
            <img id="license-2" src={License2} className="license-plate-img" alt="NY License Plate Example" />
            <img id="license-3" src={License3} className="license-plate-img" alt="NY License Plate Example" />

            <span id="fdny-1"><img src={FDNYRed} className="fdny-logo" alt="FDNY logo"/></span>
            <span id="fdny-2"><img src={FDNYRed} className="fdny-logo" alt="FDNY logo"/></span>
            <span id="sinai"><img src={MountSinai} className="mount-sinai-logo" alt="Mount Sinai logo"/></span>

            <span id="one-point-four">1.4 mi</span>
            <span id="two-point-eight">2.8 mi</span>
            <span id="three-point-two">3.2 mi</span>

            <span id="oh-four">04:17</span>
            <span id="one-oh">10:09</span>
            <span id="one-one">11:51</span>

        </div>
    </div>
}

export default OpsViewComponent;